import { Pipe, PipeTransform } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { selectPackagesInShop } from '../../actions/selector';
import { ShoppingCartState } from '../../actions/standalone';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
    name: 'packagePhoto',
    standalone: false
})
export class PackagePhotoPipe implements PipeTransform {
  packagesInShop$ = this.store.pipe(select(selectPackagesInShop));

  constructor(private store: Store<{ shoppingCart: ShoppingCartState }>) {}

  transform(packageId: string): Observable<string> {
    return this.packagesInShop$.pipe(
      map((packagesInShop) => {
        return packagesInShop.package.find(
          (packageInBasket) => packageInBasket.packageId === packageId
        ).icon;
      })
    );
  }
}
